/**
 * Fase 2 (W33, item 5.6): subtítulo curto de cada página, logo abaixo do título (como no antigo, sem travessão e numa linha no
 * desktop). Mapa central por rota: `nucleo/subtitulos.ts` acha a chave pelo caminho (`/<menu>/<módulo>/<aba>` usa
 * `paginas.<módulo>.<aba>`, que vale também para a aba projetada em outro menu). O teste `w33-paginas` percorre todas as abas.
 */
export const subtitulosPt = {
  inicio: 'Visão geral do negócio no período escolhido',
  automacoes: 'Robôs e rotinas automáticas da operação, num só lugar',
  externo: 'Sistema de fora aberto dentro do MalgoOS; o login e os dados continuam nele',
  subsistemas: 'Escolha a empresa e o sub-sistema; o menu mostra só o que é dele',
  notificacoes: 'Acompanhe todas as notificações do sistema e escolha como receber cada uma',
  conta: {
    perfil: 'Gerencie suas informações pessoais e veja os seus acessos',
    aparencia: 'Escolha tema, cor de acento, fonte e tamanho do texto só para você',
    seguranca: 'Senha, verificação em duas etapas, passkeys e sessões abertas',
    assistentes: 'Seus assistentes de IA, o que eles prepararam e o uso no período',
    lixeira: 'O que você excluiu nos últimos 30 dias, com a opção de desfazer',
    'meus-dados': 'Sua ficha de funcionário: dados pessoais, contrato, salário, documentos e histórico',
  },
  paginas: {
    cadastros: {
      pessoas: 'Clientes, fornecedores e parceiros unificados: uma pessoa pode acumular papéis',
      projetos: 'Projetos dos clientes, para agrupar contratos, tarefas e lançamentos',
      classificacao: 'Tags e setores para classificar e filtrar os cadastros',
      servicos: 'Gerencie os serviços oferecidos aos clientes',
      'servicos-contratados': 'Serviços que sua empresa contrata de terceiros (contador, limpeza, TI...)',
      'condicoes-pagamento': 'Prazos e parcelas usados nas vendas, nas compras e nos títulos',
      'formas-pagamento': 'Gerencie as formas de pagamento aceitas pela empresa',
    },
    financeiro: {
      'centros-custo': 'Gerencie os centros de custo',
      contas: 'Gerencie as contas financeiras da empresa (bancos e caixa)',
      categorias: 'Estrutura contábil da empresa',
      'entradas-saidas': 'Todo dinheiro que entrou e saiu das suas contas',
      conciliacao: 'Confira com o banco (conciliação) o que entrou e saiu das suas contas',
      'fluxo-caixa': 'Entradas e saídas por período, realizadas e previstas',
      indices: 'Índices de reajuste (IPCA, IGP-M e outros) usados nos contratos',
    },
    contas: {
      'a-receber': 'Contas que seus clientes vão pagar',
      'a-pagar': 'Contas que você vai pagar',
      cobrancas: 'Lembretes de cobrança: avisos aos clientes antes e depois do vencimento',
      recorrencias: 'Mensalidades e contas fixas emitidas sozinhas a cada ciclo',
      'notas-credito': 'Notas de crédito emitidas aos clientes, que abatem o valor a receber',
    },
    relatorios: {
      inicio: 'Análises financeiras e operacionais',
      'painel-grupo': 'Receita, despesa, saldos, contratos e pessoas de cada empresa do grupo e o total',
      inadimplencia: 'Títulos em atraso por faixa de dias',
      dre: 'Demonstrativo de resultado do exercício',
      fluxo: 'Entradas e saídas por período, realizado ou previsto, até o lançamento',
      extrato: 'Entradas e saídas (a receber e a pagar) com saldo acumulado',
      centros: 'Receitas e despesas de cada centro de custo',
      parceiros: 'Receitas por cliente e despesas por fornecedor, ranqueadas por valor',
      mrr: 'Receita recorrente mensal dos contratos ativos',
      margem: 'Receita, custo e margem de cada serviço vendido',
      quadro: 'Quantas pessoas há por departamento, função e situação',
      folha: 'Totais da folha de cada competência',
      exportacoes: 'Arquivos exportados dos relatórios, prontos para baixar',
    },
    agenda: {
      recursos: 'Profissionais, salas e equipamentos que recebem agendamentos',
      semana: 'Agendamentos da semana, por profissional ou recurso',
      dia: 'Agendamentos do dia, hora a hora',
      mes: 'Visão do mês inteiro de agendamentos',
    },
    estoque: {
      produtos: 'Gerencie o catálogo de produtos',
      variacoes: 'Variações dos produtos (tamanho, cor) e unidades de medida',
      depositos: 'Locais onde o estoque fica guardado',
      movimentacoes: 'Entradas, saídas e transferências de estoque',
      reposicao: 'Produtos abaixo do mínimo e o que precisa ser comprado',
      inventario: 'Contagens de estoque e ajustes das diferenças',
      lotes: 'Lotes e datas de validade dos produtos',
    },
    pipeline: {
      pipeline: 'Suas vendas em andamento, etapa por etapa',
      equipes: 'Equipes de vendas e quem faz parte de cada uma',
      metas: 'Metas de vendas por período, equipe e vendedor',
      'motivos-perda': 'Motivos usados ao marcar uma oportunidade como perdida',
      atividades: 'Ligações, reuniões e tarefas ligadas às oportunidades',
    },
    conversas: {
      whatsapp: 'Conversas com clientes pelo WhatsApp',
      instagram: 'Mensagens diretas recebidas pelo Instagram',
      email: 'Caixa de e-mail compartilhada com os clientes',
      portal: 'Mensagens enviadas pelos clientes no portal',
      'respostas-rapidas': 'Textos prontos para inserir nas conversas com um atalho',
      templates: 'Modelos aprovados pela Meta para iniciar conversas no WhatsApp',
      filas: 'Filas de atendimento: grupos de pessoas que respondem juntas',
      automacoes: 'Menu de entrada por canal e respostas automáticas por palavra-chave',
      site: 'Conversas abertas pelo chat dos seus sites',
      'chat-site': 'Chat para os seus sites: domínios, fila, aparência e o código para colar',
    },
    assinaturas: {
      contratos: 'Gerencie os contratos com clientes',
      planos: 'Catálogo de planos com preço, recorrência e itens para criar contratos',
      reajustes: 'Aprovação dos reajustes por índice no aniversário dos contratos indeterminados',
      onboarding: 'Configuração do ciclo do cliente e modelo do onboarding que abre na ativação do contrato',
    },
    portal: {
      acessos: 'Quem dos seus clientes entra no portal e o que cada um vê',
      configuracao: 'Como o portal do cliente aparece e o que ele oferece',
    },
    pessoas: {
      funcionarios: 'Cadastro dos funcionários da empresa',
      departamentos: 'Departamentos e quem responde por cada um',
      funcoes: 'Funções e cargos usados nos contratos de trabalho',
      contratos: 'Contratos de trabalho, admissões e desligamentos',
      documentos: 'Documentos confidenciais dos funcionários',
      jornada: 'Jornadas e escalas de trabalho',
      habilidades: 'Habilidades e certificações de cada funcionário',
    },
    folha: {
      beneficios: 'Benefícios oferecidos e quem recebe cada um',
      eventos: 'Proventos e descontos usados no cálculo da folha',
      competencias: 'Folha de cada mês, do cálculo ao fechamento',
      holerites: 'Holerites gerados para cada funcionário',
      configuracao: 'Regras e contas usadas no fechamento da folha',
    },
    compras: {
      compras: 'Compras de serviço que geram títulos a pagar',
      requisicoes: 'Pedidos internos de compra, para aprovação',
      cotacoes: 'Preços pedidos aos fornecedores, lado a lado',
      pedidos: 'Pedidos de compra enviados aos fornecedores',
      recebimentos: 'Conferência do que chegou dos pedidos de compra',
      fornecedores: 'Fornecedores com quem a empresa compra',
    },
    tarefas: {
      kanban: 'Tarefas em colunas por situação, para arrastar e soltar',
      lista: 'Todas as tarefas em lista, com filtros',
      minhas: 'As tarefas atribuídas a você',
      painel: 'Indicadores das tarefas: prazos, atrasos e entregas',
      quadros: 'Quadros que organizam as tarefas por projeto ou equipe',
      projetos: 'Projetos com cliente, equipe, prazo, orçamento e o quadro das tarefas',
      marcos: 'Datas importantes dos projetos, da mais próxima para a mais distante',
    },
    equipe: {
      chat: 'Conversas e canais da equipe',
    },
    automacoes: {
      painel: 'Painel dos robôs: estado, última e próxima execução, placar do mês e fila de pendências',
      feriados: 'Calendário de feriados que as janelas de dias úteis dos robôs pulam',
      fluxos: 'Automações de conversa do Instagram e do WhatsApp, desenhadas em canvas',
      broadcast: 'Disparo de template do WhatsApp para um público, com consentimento, ritmo e relatório',
    },
    treinamento: {
      cursos: 'Cursos e aulas disponíveis para a equipe',
      trilhas: 'Sequências de cursos por função ou objetivo',
      progresso: 'Quem fez cada curso e o andamento de cada pessoa',
    },
    ponto: {
      marcar: 'Bata o seu ponto: hora do servidor, marcações de hoje e o horário do dia',
      marcacoes: 'Marcações de ponto com a origem, a hora do aparelho e a localização',
      espelho: 'Esperado pela jornada contra o trabalhado, dia a dia, com extras, atrasos e faltas',
      ajustes: 'Marcação esquecida ou que não vale, com justificativa e aprovação',
      banco: 'Saldo de horas dos meses fechados e o que vence em breve',
      fechamentos: 'Meses fechados por empresa: trava o ponto e entrega o resultado à folha',
      fiscal: 'Ponto oficial (REP-P) e os arquivos AFD e AEJ por período, assinados com o certificado',
      configuracao: 'Tolerâncias, contratos que batem ponto e a política por empresa, departamento ou funcionário',
    },
    ausencias: {
      pedidos: 'Férias, atestados, folgas e licenças pedidos pela equipe',
      aprovacoes: 'Pedidos de ausência esperando a sua decisão',
      calendario: 'Quem está ausente ou pediu ausência em cada mês',
      saldos: 'Dias de direito, usados e disponíveis de cada funcionário no ano',
      tipos: 'Tipos de ausência e a regra de saldo, contagem e aprovação',
    },
    documentos: {
      arquivos: 'Arquivos ligados a clientes, projetos e funcionários, com as versões',
      contratos: 'Contratos gerados de modelos com os dados do cadastro',
      assinaturas: 'Documentos enviados para assinar, com a trilha de cada assinatura',
    },
    despesas: {
      despesas: 'Gastos da equipe com comprovante, categoria e centro de custo',
      aprovacoes: 'Despesas enviadas esperando a sua decisão',
      reembolsos: 'Despesas aprovadas que viram conta a pagar no Contas',
      centros: 'Aprovadas e reembolsadas no período, por centro de custo',
    },
    integracoes: {
      conectores: 'Serviços externos ligados ao sistema: WhatsApp, e-mail, cobrança e agenda',
      webhooks: 'Avisos enviados a outros sistemas quando algo acontece aqui',
      api: 'Chaves de acesso à API do sistema e o registro das chamadas',
      mcp: 'Servidor MCP para agentes de IA usarem o sistema',
      'conta-azul': 'Conta Azul até o corte: espelho, comparação com o MalgoOS e arquivo para importar',
    },
    admin: {
      painel: 'Saúde do sistema: banco, filas, versão no ar e alertas',
      modulos: 'Instale e desligue módulos sem deploy',
      tenants: 'Tenants e workspaces atendidos pela plataforma',
      usuarios: 'Gerencie os usuários e permissões do sistema',
      auditoria: 'Registro de quem fez o quê, e quando',
      saude: 'Versões, serviços e tarefas agendadas do servidor',
      erros: 'O que a pessoa tentava fazer quando a tela deu erro, para corrigir e refazer',
      'historico-telas': 'As telas antes e depois de cada mudança, com as imagens do servidor',
      'tela-entrada': 'A logo e a imagem de fundo do login e da saída, iguais para todos',
      'uso-ia': 'Tokens e custo do Claude Code por dia, semana, mês e ano',
    },
    configuracoes: {
      empresa: 'Dados das empresas do workspace, usados em documentos e e-mails',
      aparencia: 'Personalize o nome, a logo, as cores e a fonte do sistema',
      modos: 'Como cada módulo funciona: simples ou detalhado',
      subsistemas: 'Onde cada página aparece: por sub-sistema, no workspace e em cada empresa',
      sequencias: 'Numeração automática dos documentos, sem buraco nem repetição',
      campos: 'Campos personalizados nos formulários e nas tabelas',
      'campos-telas': 'Quais campos aparecem e quais são obrigatórios em cada tela de cadastro',
      visoes: 'Filtros, colunas e ordenação que você salvou nas tabelas',
      modelos: 'Textos prontos de e-mails, mensagens e documentos',
      estruturas: 'Etapas e funções usadas pelos outros módulos',
      crm: 'Atalho para as Configurações do CRM: funis, motivos de perda, propostas e workflows',
    },
  },
};
